import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

interface IProps {
  simpleMode: boolean;
}
const useStyles = makeStyles((theme: Theme) => ({
  container: {
    height: '100%',
    margin: '0 auto',
    display: 'flex',
    maxWidth: '800px',
    flexDirection: 'column',
    justifyContent: (props: IProps) => (props.simpleMode ? 'unset' : 'center'),
    padding: (props: IProps) => (props.simpleMode ? '10px' : '30px'),
    boxSizing: 'border-box',
    gap: '15px',
    '& img': {
      margin: '0 auto',
      width: (props: IProps) => (props.simpleMode ? '100%' : '40vw'),
      maxWidth: '500px',
      objectFit: 'contain',
    },
    background: theme.palette.secondary.main,
  },
  form: {
    background: theme.palette.secondary.main,
    height: '100%',
  },
  external: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    justifyItems: 'center',
    gap: (props: IProps) => (props.simpleMode ? '10px' : '80px'),
    '& svg': {
      width: '250px !important',
      maxHeight: '25px !important',
      cursor: 'pointer',
      padding: '10px 30px',
      borderRadius: '10px',
      backgroundColor: '#B2B2B217',
      filter: theme.palette.mode === 'dark' ? 'brightness(100)' : undefined,
      '& path': {
        filter: theme.palette.mode === 'dark' ? 'brightness(100) contrast(0)' : undefined,
      },
    },
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& img': {
      filter:
        theme.palette.mode === 'dark' ? 'brightness(100) grayscale(1) contrast(100)' : undefined,
    },
  },
  divider: {
    margin: (props: IProps) => (props.simpleMode ? 'unset' : '20px 16px !important'),
  },
  simplified: {
    flexDirection: 'column',
    '& svg': {
      width: '100%',
      cursor: 'pointer',
      padding: '10px',
    },
  },
}));

export default useStyles;
